declare const jQuery: any;
const $ = jQuery;

export function initCf7OptIn(): void
{
    const privacyPolicyUrl: string = window["iw"].privacyPolicyUrl;
    if (!privacyPolicyUrl)
    {
        return;
    }
    const $inputs = $(`.wpcf7 .wpcf7-form-control-wrap.opt-in input[type="checkbox"]`);
    if ($inputs.length === 0)
    {
        return;
    }
    $inputs.each(function () {
        const $label = $(this).parent().find(".wpcf7-list-item-label");
        const linkHtml: string = `<a href="${privacyPolicyUrl}" target="_blank">privacy policy</a>`;
        const html: string = $label.html().replace(/privacy policy/gi, linkHtml);
        $label.html(html);
    });
}
